import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = [
        'absentRadio',
        'absentReasonField',
        'endTimeField',
        'leftEarlyRadio',
        'startTimeField',
        'startTimeInput',
        'timeFields',
        'wholeDayCheckbox'
    ]

    connect() {
        this.update()
    }

    update() {
        const isAbsent    = this.absentRadioTarget.checked
        const isLeftEarly = this.leftEarlyRadioTarget.checked
        const isWholeDay  = this.wholeDayCheckboxTarget.checked

        this.absentReasonFieldTarget.classList.toggle('d-none', !isAbsent)
        this.timeFieldsTarget.classList.toggle('d-none', isWholeDay)
        this.leftEarlyRadioTarget.disabled = isWholeDay

        if (isWholeDay && isLeftEarly) {
            const firstRadio = this.element.querySelector('input[name*="mutation_type"]:not(:disabled)')
            if (firstRadio) firstRadio.checked = true
        }

        if (!isWholeDay) {
            this.endTimeFieldTarget.classList.toggle('d-none', isLeftEarly)
            this.startTimeInputTarget.required = isLeftEarly
        }
    }
}
